import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		timocomCustomerRef: Yup.string()
			.required(t("fill_required_fields"))
			.test(
				"isNumericTimocomID",
				t("timocom_id_has_to_contain_only_numbers"),
				(value) => !value || /^\d+$/.test(value)
			)
			.test(
				"isValidTimocomID",
				t("timocom_id_has_to_contain_max_6_characters"),
				(value) => !value || /^\d{1,6}$/.test(value)
			),
	});
};
